import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IDamageFollowUp, IDDFollowUp } from "../models/prException";
import { throwApiError } from "./apiError";
/**
 * CRETE API call using Axios
 * @returns - Save and submit Investigation api and return same object
 */

export const DamageFollowupAPI = async (
  params: IDamageFollowUp | IDDFollowUp ,
  osdNumber: number,
  action: string
) => {
    try {
      const url = `${getUrl(ApiType.REFUSAL_FOLLOWUP).replace(
        ":osdNumber",
        osdNumber.toString()
      )}/${action}`;
      const response = await axios.post(url, params);
      return response.data;
    } catch (error: any) {
      return throwApiError(error, ErrorMessages.bnfFollowUpAPIError, { badRequestOrder: "errorsFirst" });
    }
};
